import { render, staticRenderFns } from "./SecurityConfigModal.vue?vue&type=template&id=7264f2a7&scoped=true&"
import script from "./SecurityConfigModal.vue?vue&type=script&lang=js&"
export * from "./SecurityConfigModal.vue?vue&type=script&lang=js&"
import style0 from "./SecurityConfigModal.vue?vue&type=style&index=0&id=7264f2a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7264f2a7",
  null
  
)

export default component.exports